<template>
  <el-dialog
    title="编码重复的商品明细"
    :visible="visible"
    @update:visible="(v) => $emit('update:visible', v)"
    width="800px"
  >
    <div class="flex">
      <div class="flex-1">
        <div style="height: 40px;" class="text-center text-orange">编码重复商品</div>
        <el-table
          :data="oldItem"
          >
          <el-table-column
            prop="mainImage"
            label="商品图">
            <template slot-scope="scope">
              <ListLazyImg :src="scope.row.mainImage" />
            </template>
          </el-table-column>
          <el-table-column
            prop="title"
            label="商品名">
          </el-table-column>
          <el-table-column
            prop="outerId"
            label="款式编码">
          </el-table-column>
          <el-table-column
            prop="skuOuterId"
            label="商品编码"
            :formatter="formatterSkuOuterId">
          </el-table-column>
        </el-table>
      </div>
      <div class="text-orange ftsz16">
        <i class="kmt-iconfont kmt-icon-bianmazhongfu" />
      </div>
      <div class="flex-1">
        <div style="height: 40px;" class="text-center text-orange">需添加的分销商品</div>
        <el-table
          :data="addItem"
          >
          <el-table-column
            prop="mainImage"
            label="商品图">
            <template slot-scope="scope">
              <ListLazyImg :src="scope.row.mainImage" />
            </template>
          </el-table-column>
          <el-table-column
            prop="title"
            label="商品名">
          </el-table-column>
          <el-table-column
            prop="outerId"
            label="款式编码">
          </el-table-column>
          <el-table-column
            prop="skuOuterId"
            label="商品编码"
            :formatter="formatterSkuOuterId">
          </el-table-column>
        </el-table>
      </div>
    </div>

  </el-dialog>
</template>

<script>
// 编码重复的商品明细弹窗
import ListLazyImg from '@/components/ListLazyImg/index.vue'
export default {
  components: {
    ListLazyImg
  },
  props: {
    oldItem: {
      type: Array,
      default() {
        return []
      }
    },
    addItem: {
      type: Array,
      default() {
        return []
      }
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    formatterSkuOuterId(row) {
      return row.skuOuterId || '-'
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
